import * as React from "react";
import { cn } from "../../lib/utils";
import { Label } from "./label";

const Input = React.forwardRef(
  ({ className, type, label, labelClassName, id, isError, ...props }, ref) => {
    return (
      <div className="flex flex-col w-full">
        {label && (
          <Label
            htmlFor={id}
            className={cn("text-sm font-semibold text-gray-700 mb-2.5", labelClassName)}
          >
            {label}
          </Label>
        )}

        <input
          id={id}
          type={type}
          ref={ref}
          style={{ outline: 'none', boxShadow: 'none' }}
          className={cn(
            "w-full h-12 px-4 border border-gray-300 rounded-lg bg-white text-sm text-gray-900 placeholder-gray-400 hover:border-gray-400 focus:border-[var(--btn-primary-bg)] focus:bg-[var(--btn-primary-bg)]/3 transition-all duration-200 [outline:none] focus:[outline:none] focus-visible:[outline:none] [box-shadow:none] focus:[box-shadow:none]",
            type === "number" && "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
            isError && "border-red-500 focus:border-red-500 focus:bg-white",
            "disabled:bg-gray-100 disabled:text-gray-500 disabled:border-gray-300 disabled:cursor-not-allowed",
            className
          )}
          {...props}
        />
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };